import { TYPE_REMISE_FRONT_REMISE_POURCENTAGE, TYPE_REMISE_FRONT_MAJORATION_POURCENTAGE } from '@/configuration/devisConf';
import calculArrondi from '@/services/calcul/calculArrondi';

export default function findPourcentageRemise(ligneRemise, prixAAtteindre, totalHt) {
  let remise = 0;
  if (totalHt !== 0) {
    remise = (100 * (prixAAtteindre - totalHt)) / totalHt;
    remise = calculArrondi(remise, 5);
  }
  ligneRemise.remise = Math.abs(remise);
  if (remise < 0) ligneRemise.typeRemise = TYPE_REMISE_FRONT_REMISE_POURCENTAGE;
  else ligneRemise.typeRemise = TYPE_REMISE_FRONT_MAJORATION_POURCENTAGE;
}
